'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaveDraftButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/SaveDraftButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SaveDraftButton = exports.SaveDraftButton = function (_BcReactComponent) {
  _inherits(SaveDraftButton, _BcReactComponent);

  function SaveDraftButton(props) {
    _classCallCheck(this, SaveDraftButton);

    var _this = _possibleConstructorReturn(this, (SaveDraftButton.__proto__ || Object.getPrototypeOf(SaveDraftButton)).call(this, props));

    _this.bindAll('canSaveAsDraft', 'renderMessage', 'renderIcon');
    return _this;
  }

  _createClass(SaveDraftButton, [{
    key: 'canSaveAsDraft',
    value: function canSaveAsDraft() {
      var _props = this.props,
          listHasUnsavedChanges = _props.listHasUnsavedChanges,
          savingDraft = _props.savingDraft,
          publishing = _props.publishing,
          editingAnchorBib = _props.editingAnchorBib,
          list = _props.list,
          items = _props.items;


      var hasAnchorBibIfRequired = list.get('listType') !== 'read_a_like' || list.get('anchorBib');
      var hasFourOrMoreItems = items.size >= 4;
      var isAlreadySaving = savingDraft || publishing;

      return !isAlreadySaving && hasAnchorBibIfRequired && listHasUnsavedChanges && !editingAnchorBib && hasFourOrMoreItems;
    }
  }, {
    key: 'renderMessage',
    value: function renderMessage() {
      var _props2 = this.props,
          listHasUnsavedChanges = _props2.listHasUnsavedChanges,
          savingDraft = _props2.savingDraft,
          list = _props2.list;


      if (savingDraft && list.get('isPrivate')) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_saving_draft' });
      } else if (!listHasUnsavedChanges && list.get('isPrivate')) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_draft_saved' });
      }

      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_save_draft' });
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon() {
      var savingDraft = this.props.savingDraft;


      if (savingDraft) {
        return _react2.default.createElement(_baseIcons.Spinner, { color: '' });
      }

      return _react2.default.createElement(_baseIcons.Lock, { color: '' });
    }
  }, {
    key: 'render',
    value: function render() {
      var handleClick = this.props.handleClick;

      var disabledClass = this.canSaveAsDraft() ? '' : 'disabled';

      return _react2.default.createElement(
        _baseButtons.Button,
        {
          className: 'btn-secondary cp-user-list-save-draft-button save-btn ' + disabledClass,
          handleClick: handleClick,
          'data-test-id': 'save-draft-button' },
        this.renderIcon(),
        _react2.default.createElement(
          'span',
          { className: 'text' },
          this.renderMessage()
        )
      );
    }
  }]);

  return SaveDraftButton;
}(_baseBcReactComponent2.default);

SaveDraftButton.propTypes = {
  list: _bcPropTypes.listShape.isRequired,
  items: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  handleClick: _react2.default.PropTypes.func,
  listHasUnsavedChanges: _react2.default.PropTypes.bool.isRequired,
  savingDraft: _react2.default.PropTypes.bool.isRequired,
  publishing: _react2.default.PropTypes.bool.isRequired,
  editingAnchorBib: _react2.default.PropTypes.bool.isRequired
};

exports.default = SaveDraftButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/save-draft-button/components/SaveDraftButton.component.js
// module id = 1333
// module chunks = 0